import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import * as Yup from 'yup';
import { entidades } from '../../data/entidades';
import { startRegister } from '../../middlewares/register';
import { useFetch } from '../../hook/useFetch';

import './form.css';

export const RegisterForm = ({ ev_id }) => {
  const [statusReq, setStatusReq] = useState({ ok: false, body: {} });

  const handleSubmit = async (values) => {
    const { code, ...data } = await startRegister(values, 'registro/' + ev_id);

    if (code >= 200 && code <= 299) {
      setStatusReq({ ok: true, body: data });
    }
  };

  return (
    <>
      {statusReq.ok && statusReq.body && (
        <Navigate to={`/perfil/${statusReq.body.r_id}`} replace={true} />
      )}
      <Formik
        initialValues={{
          r_nombre: '',
          r_primer_apellido: '',
          r_segundo_apellido: '',
          r_correo: '',
          r_contrasena: '',
          r_institucion: '',
          r_sostenimiento: '',
          r_puesto: '',
          r_celular: '',
          r_sexo: '',
          r_entidad: '',
          r_nivel_estudios: '',
          r_rfc: '',
          ev_id,
          terms: false,
        }}
        onSubmit={handleSubmit}
        validationSchema={Yup.object({
          r_nombre: Yup.string()
            .max(49, 'Máximo 49 caracteres')
            .required('Campo obligatorio'),
          r_primer_apellido: Yup.string()
            .max(49, 'Máximo 49 caracteres')
            .required('Campo obligatorio'),
          r_segundo_apellido: Yup.string()
            .max(49, 'Máximo 49 caracteres')
            .required('Campo obligatorio'),
          r_correo: Yup.string()
            .max(59, 'Máximo 59 caracteres')
            .email('Debe tener formato válido, ej.: xxxx@xxxxx.xxx')
            .required('Campo obligatorio'),
          r_contrasena: Yup.string()
            .min(5, 'Mínimo debe contener 5 caracteres')
            .max(49, 'Máximo 49 caracteres')
            .required('Campo obligatorio'),
          r_institucion: Yup.string()
            .max(249, 'Máximo 249 caracteres')
            .required('Campo obligatorio'),
          r_sostenimiento: Yup.string().required('Campo obligatorio'),
          r_puesto: Yup.string().required('Campo obligatorio'),
          r_celular: Yup.string()
            .max(20, 'Máximo 20 caracteres')
            .min(10, 'Mínimo 10 caracteres')
            .required('Campo obligatorio'),
          r_sexo: Yup.string().required('Campo obligatorio'),
          r_entidad: Yup.string().required('Campo obligatorio'),
          r_nivel_estudios: Yup.string().required('Campo obligatorio'),
          r_rfc: Yup.string()
            .min(10, 'Mínimo debe contener 10 caracteres')
            .max(13, 'Máximo 13 caracteres'),
          ev_id: Yup.number('Error en la URL').required(
            'Error en la URL, faltan parámetros'
          ),
        })}
      >
        {({ errors, touched }) => (
          <Form noValidate>
            <div className='row field-section'>
              <div className='col-md-4 '>
                <ErrorMessage
                  name='r_nombre'
                  component='span'
                  className='field-error'
                />
                <Field
                  name='r_nombre'
                  type='text'
                  placeholder={'Nombre (s)'}
                  className={`form-input  ${
                    touched.r_nombre && errors.r_nombre && 'form-input-err'
                  }`}
                />
              </div>
              <div className='col-md-4  '>
                <ErrorMessage
                  name='r_primer_apellido'
                  component='span'
                  className='field-error'
                />
                <Field
                  name='r_primer_apellido'
                  type='text'
                  placeholder={'Primer apellido'}
                  className={`form-input  ${
                    touched.r_primer_apellido &&
                    errors.r_primer_apellido &&
                    'form-input-err'
                  }`}
                />
              </div>
              <div className='col-md-4 '>
                <ErrorMessage
                  name='r_segundo_apellido'
                  component='span'
                  className='field-error'
                />
                <Field
                  name='r_segundo_apellido'
                  type='text'
                  placeholder={'Segundo apellido'}
                  className={`form-input  ${
                    touched.r_segundo_apellido &&
                    errors.r_segundo_apellido &&
                    'form-input-err'
                  }`}
                />
              </div>
              <div className='col-md-4 '>
                <ErrorMessage
                  name='r_celular'
                  component='span'
                  className='field-error'
                />
                <Field
                  name='r_celular'
                  type='text'
                  placeholder={'Número de celular'}
                  className={`form-input  ${
                    touched.r_celular && errors.r_celular && 'form-input-err'
                  }`}
                />
              </div>

              <div className='col-md-4 '>
                <ErrorMessage
                  name='r_sexo'
                  component='span'
                  className='field-error'
                />
                <Field
                  name='r_sexo'
                  as='select'
                  className={`form-input  ${
                    touched.r_sexo && errors.r_sexo && 'form-input-err'
                  }`}
                >
                  <option>Sexo</option>
                  <option value='Femenino'>Femenino</option>
                  <option value='Masculino'>Masculino</option>
                </Field>
              </div>

              <div className='col-md-4 '>
                <ErrorMessage
                  name='r_entidad'
                  component='span'
                  className='field-error'
                />
                <Field
                  name='r_entidad'
                  as='select'
                  className={`form-input  ${
                    touched.r_entidad && errors.r_entidad && 'form-input-err'
                  }`}
                >
                  <option>Entidad</option>
                  {entidades.map((e) => (
                    <option key={e.id} value={e.nombre}>
                      {e.nombre}
                    </option>
                  ))}
                </Field>
              </div>
              <div className='col-md-6 '>
                <ErrorMessage
                  name='r_nivel_estudios'
                  component='span'
                  className='field-error'
                />
                <Field
                  name='r_nivel_estudios'
                  as='select'
                  className={`form-input  ${
                    touched.r_nivel_estudios &&
                    errors.r_nivel_estudios &&
                    'form-input-err'
                  }`}
                >
                  <option>Nivel de estudios</option>
                  <option value='Licenciatura'>Licenciatura</option>
                  <option value='Especialidad'>Especialidad</option>
                  <option value='Maestría'>Maestría</option>
                  <option value='Doctorado'>Doctorado</option>
                </Field>
              </div>

              <div className='col-md-6 '>
                <ErrorMessage
                  name='r_rfc'
                  component='span'
                  className='field-error'
                />
                <Field
                  name='r_rfc'
                  type='text'
                  placeholder={'RFC'}
                  className={`form-input  ${
                    touched.r_rfc && errors.r_rfc && 'form-input-err'
                  }`}
                />
              </div>
              <div className='col-md-6 '>
                <ErrorMessage
                  name='r_correo'
                  component='span'
                  className='field-error'
                />
                <Field
                  name='r_correo'
                  type='email'
                  placeholder={'Correo'}
                  className={`form-input  ${
                    touched.r_entidad && errors.r_entidad && 'form-input-err'
                  }`}
                />
              </div>
              <div className='col-md-6 '>
                <ErrorMessage
                  name='r_contrasena'
                  component='span'
                  className='field-error'
                />
                <Field
                  name='r_contrasena'
                  type='password'
                  placeholder={'Defina una contraseña'}
                  className={`form-input  ${
                    touched.r_contrasena &&
                    errors.r_contrasena &&
                    'form-input-err'
                  }`}
                />
              </div>
              <div className='col-md-12 '>
                <ErrorMessage
                  name='r_institucion'
                  component='span'
                  className='field-error'
                />
                <Field
                  name='r_institucion'
                  type='text'
                  placeholder={'Institución'}
                  className={`form-input  ${
                    touched.r_institucion &&
                    errors.r_institucion &&
                    'form-input-err'
                  }`}
                />
              </div>
              <div className='col-md-6 '>
                <ErrorMessage
                  name='r_sostenimiento'
                  component='span'
                  className='field-error'
                />
                <Field
                  name='r_sostenimiento'
                  as='select'
                  className={`form-input  ${
                    touched.r_sostenimiento &&
                    errors.r_sostenimiento &&
                    'form-input-err'
                  }`}
                >
                  <option>Sostenimiento de la institución</option>
                  <option value='Pública'>Pública</option>
                  <option value='Privada'>Privada</option>
                </Field>
              </div>
              <div className='col-md-6 '>
                <ErrorMessage
                  name='r_puesto'
                  component='span'
                  className='field-error'
                />
                <Field
                  name='r_puesto'
                  as='select'
                  className={`form-input  ${
                    touched.r_puesto && errors.r_puesto && 'form-input-err'
                  }`}
                >
                  <option>Puesto</option>
                  <option value='Director'>Director</option>
                  <option value='Subdirector'>Subdirector</option>
                  <option value='Profesor-investigador'>
                    Profesor-investigador
                  </option>
                  <option value='Docente'>Docente</option>
                  <option value='Estudiante'>Estudiante</option>
                  <option value='Otro'>Otro</option>
                </Field>
              </div>

              <div className='col-md-12 '>
                <ErrorMessage
                  name='terms'
                  component='span'
                  className='field-error'
                />
                <label>
                  <Field
                    name='terms'
                    type='checkbox'
                    className={`form-checkbox`}
                  />
                  Doy autorización para que mis datos se puedan compartir con
                  los expositores a cargo de los Webinars; así ellos podrán
                  enviarme información sobre los temas que me interesan.
                </label>
              </div>

              <div className='col-md-12'>
                <button type='submit' className='button-default'>
                  Aceptar
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
